import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { BUILDER_MODELS } from '~/builder/constants/models';
import { isBuilderPreview } from '~/builder/utils/isBuilderPreview';
import useBuilderJson from '~/builder/utils/useBuilderJson';
import { Link } from '~/techstyle-shared/next-routes';
import { useProductDetailContext } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const LinkContainer = styled.span`
  margin-left: 8px;
  font-size: 14px;
`;

const StyledLink = styled.a`
  text-decoration: underline;
`;

export default function ShopByColorLink({ masterProductId }) {
  const { query } = useRouter();
  const productDetailFromCtx = useProductDetailContext();
  const productDetail = productDetailFromCtx;
  const isBundle = productDetail.bundleProducts?.length > 0;
  const currentProduct = isBundle
    ? productDetail.bundleProducts.find(
        (product) => product.masterProductId === masterProductId
      )
    : productDetail.product;

  const LinkModelProperties = {
    modelName: BUILDER_MODELS.PAGE,
    query: {
      data: {
        shopByColorFplGlobalCode: {
          $in:
            currentProduct?.activeFeaturedProductLocationCodeList?.map(
              (code) => code.featuredProductLocationCode
            ) || [],
        },
      },
    },
    additionalQueryParams: {
      limit: 1,
      fields: 'data.url',
      sort: {
        lastUpdated: -1,
      },
    },
    builderQueries: {
      isPreview: isBuilderPreview({ query }),
    },
    options: {
      skipUserAttributes: true,
    },
  };

  const { builderJson, isLoading } = useBuilderJson(LinkModelProperties);

  if (
    isLoading ||
    !builderJson ||
    !currentProduct?.activeFeaturedProductLocationCodeList?.length
  ) {
    return null;
  }

  const url = builderJson?.data?.url;

  return (
    <LinkContainer>
      <Link href={url}>
        <StyledLink>
          <FormattedMessage
            id="site_pdp.shop_this_color"
            defaultMessage="(Shop This Color)"
          />
        </StyledLink>
      </Link>
    </LinkContainer>
  );
}

ShopByColorLink.propTypes = {
  masterProductId: PropTypes.number,
};
